import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d5af83b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3d5af83b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5af83b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d5af83b')) {
      api.createRecord('3d5af83b', component.options)
    } else {
      api.reload('3d5af83b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3d5af83b&scoped=true&", function () {
      api.rerender('3d5af83b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/search/index.vue"
export default component.exports